import { Header, DisplayBttn, Body, Footer } from "./components";
import { useState, useEffect } from "react";
import "./App.css";

function App() {
  //const [lightMode, setLightMode] = useState("light");

  // useEffect(() => {
  //   document.body.className = lightMode;
  // }, [lightMode]);

  return (
    <div className="App">
      <Header />
      <Body />
      <Footer />
    </div>
  );
}

export default App;
// <DisplayBttn lightMode={lightMode} setLightMode={setLightMode} />
